module.exports = __webpack_public_path__ + "media/entities/1303-bdbfa85e.png";